var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-combobox',{attrs:{"value":_vm.value,"items":_vm.candidates,"label":_vm.label,"rules":[
    _vm.allValid,
    function (v) { return !!v.length || (_vm.required ? "at least one recipient is required" : true); }
  ],"multiple":"","deletable-chips":"","small-chips":"","hide-selected":""},on:{"input":function($event){return _vm.$emit('input', $event)}},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
  var item = ref.item;
  var parent = ref.parent;
  var selected = ref.selected;
return [_c('v-chip',{key:JSON.stringify(item),attrs:{"color":_vm.isValid(item) ? '' : 'error',"input-value":selected,"small":"","close":""},on:{"input":function($event){return parent.selectItem(item)},"click:close":function($event){return parent.selectItem(item)}}},[_vm._v(" "+_vm._s(item)+" ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }